import { Component, OnInit } from '@angular/core';
import { UserRoles } from '../../constants';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  buttons = [
    {
      id: 11,
      title: 'errorReports',
      route: '/error-reports',
      role: ['SUPERADMIN','UK_ADMIN'],
      imageUrl: 'assets/img/custom/bug.png'
    },
    {
      id: 1,
      title: 'EPC',
      route: '/epc',
      role: UserRoles.All,
      imageUrl: 'assets/img/custom/epc.png'
    },
    {
      id: 2,
      title: 'ETD',
      route: '/etd',
      role: ['SUPERADMIN','UK_ADMIN'],
      imageUrl: 'assets/img/custom/etd.png'
    },
    {
      id: 3,
      title: 'ISBN',
      route: '/isbn',
      role: ['SUPERADMIN','UK_ADMIN'],
      imageUrl: 'assets/img/custom/isbn.png'
    },
    {
      id: 4,
      title: 'HELPDESK',
      route: '/helpdesk',
      role: ['SUPERADMIN','UK_ADMIN'],
      imageUrl: 'assets/img/custom/helpdesk.png'
    },
    {
      id: 5,
      title: 'ROOMBOOK',
      route: '/roombook',
      role: ['SUPERADMIN','UK_ADMIN'],
      imageUrl: 'assets/img/custom/roombook.png'
    },
    {
      id: 6,
      title: 'ZP',
      route: '/zp',
      role: ['SUPERADMIN','UK_ADMIN'],
      imageUrl: 'assets/img/custom/zp.png'
    },
    {
      id: 7,
      title: 'UIK',
      route: '/uik',
      role: ['SUPERADMIN','UK_ADMIN'],
      imageUrl: 'assets/img/custom/uik.png'
    },
    {
      id: 8,
      title: 'ORIGINALITY',
      route: '/originality',
      role: ['SUPERADMIN','UK_ADMIN'],
      imageUrl: 'assets/img/custom/percent.png'
    },
    {
      id: 9,
      title: 'others',
      route: '/others',
      role: ['SUPERADMIN','UK_ADMIN'],
      imageUrl: 'assets/img/custom/others.png'
    },
    {
      id: 10,
      title: 'notifications',
      route: '/notifications',
      role: ['SUPERADMIN','UK_ADMIN'],
      imageUrl: 'assets/img/custom/notification.png'
    }
  ];

  quickActions = [
    {
      id: 1,
      title: 'Generovať PROMO',
      route: '/originality#settings',
      role: ['SUPERADMIN','UK_ADMIN']
    },
    {
      id: 2,
      title: 'ETD-FAQ',
      route: '/etd#faq',
      role: ['SUPERADMIN','UK_ADMIN']
    }
  ];
  constructor() {}

  ngOnInit() {}
}
